export enum DIALOG {
  CHANGE_AVATAR = "CHANGE_AVATAR", //modal thay đổi avatar
  CHANGE_BANK_INFORMATION = "CHANGE_BANK_INFORMATION", //modal thay đổi thông tin ngân hàng
  CHANGE_BASIC_INFORMATION = "CHANGE_BASIC_INFORMATION", //modal thay đổi thông tin cá nhân
  CHANGE_EDUCATION_INFORMATION = "CHANGE_EDUCATION_INFORMATION", //modal thay đổi thông tin học vấn
  CHANGE_MARITAL_INFORMATION = "CHANGE_MARITAL_INFORMATION", //modal thay đổi thân nhân
  CHANGE_RESIDENCE_INFORMATION = "CHANGE_RESIDENCE_INFORMATION", //modal thay đổi đia chỉ
  CHANGE_PROFILE_WORK_BEFORE = "CHANGE_PROFILE_WORK_BEFORE", //modal quá trình công tác
  PERSONAL_INFORMATION_CHANGED_HISTORY = "PERSONAL_INFORMATION_CHANGED_HISTORY", // modal xem lịch sử thay đổi thông tin cá nhân
  VIEW_DETAIL_INTERNAL_DOCUMENT = "VIEW_DETAIL_INTERNAL_DOCUMENT", //modal xem chi tiết văn bản
  VIEW_DETAIL_RELATED_DOCUMENT = "VIEW_DETAIL_RELATED_DOCUMENT", //modal xem chi tiết văn bản
  TWO_FA = "TWO_FA", //modal xác thực 2 lớp
  /** Xác thực OTP tra cứu thu nhập (erp-recruitment/income/{otp}) */
  MODAL_VERIFY_INCOME = "MODAL_VERIFY_INCOME",
  REQUEST_LEAVE = "REQUEST_LEAVE", //modal xin nghỉ
  VIEW_DAY_DETAIL = "VIEW_DAY_DETAIL", //modal xem chi tiết ngày
  MANAGER_VIEW_REQUEST_LEAVE_DETAIL = "VIEW_REQUEST_LEAVE_DETAIL", //modal xem chi tiết đơn xin nghỉ
  MANAGER_VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL = "VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL",
  VIEW_REQUEST_LEAVE_DETAIL = "VIEW_REQUEST_LEAVE_DETAIL", //modal xem chi tiết đơn xin nghỉ
  VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL = "VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL", //modal xem chi tiết đơn xin đi muộn về sớm
  REQUEST_ARRIVING_LATE_LEAVING_EARLY = "REQUEST_ARRIVING_LATE_LEAVING_EARLY", //modal xin đi muộn về sớm
  APPROVE_REQUEST_POPUP = "APPROVE_REQUEST_POPUP", //modal xác nhận
  MODAL_CONFIRM = "MODAL_CONFIRM", //modal xác nhận
  TIMEKEEPING_DETAIL = "TIMEKEEPING_DETAIL", //modal xem chi tiết chấm công
  RESPONSE_DETAIL = "RESPONSE_DETAIL", //modal xem chi tiết phản hồi
  SEND_FEEDBACK = "SEND_FEEDBACK", //modal gửi phản hồi
  VOTE_EVENT = "VOTE_EVENT", //modal bình chọn sự kiện
  CONFIRM_VOTE = "CONFIRM_VOTE", //modal xác nhận bình chọn
  TIMEKEEPING_DETAIL_MANAGER = "TIMEKEEPING_DETAIL_MANAGER",
  EMPLOYEE_REQUEST_LEAVE_DETAIL = "VIEW_EMPLOYEE_REQUEST_LEAVE_DETAIL", //modal xem chi tiết đơn xin nghỉ
  EMPLOYEE_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL = "VIEW_EMPLOYEE_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL", //modal xem chi tiết đơn xin đi muộn về sớm
  EMPLOYEE_RESPONSE_DETAIL = "EMPLOYEE_RESPONSE_DETAIL", //modal xem chi tiết phản hồi
  CHECKIN_ONLINE = "CHECKIN_ONLINE", //modal chấm công online
  IMPORT_TIMEKEEPING = "IMPORT_TIMEKEEPING",
  CONFIRM_EDIT = "CONFIRM_EDIT", //modal xác nhận chỉnh sửa
  EARLY_REGISTRATION = "EARLY_REGISTRATION", //modal đăng ký đi làm sớm
  EARLY_REGISTRATION_MANAGER = "EARLY_REGISTRATION_MANAGER", //modal đăng ký đi làm sớm
  CONFIRM_APPROVE_RECRUITMENT_REQUIREMENT = "CONFIRM_APPROVE_RECRUITMENT_REQUIREMENT", // modal xác nhận duyệt yêu cầu tuyển dụng
  CONFIRM_REJECT_RECRUITMENT_REQUIREMENT = "CONFIRM_REJECT_RECRUITMENT_REQUIREMENT", // modal xác nhận từ chối yêu cầu tuyển dụng
  CONFIRM_DELETE_RECRUITMENT_REQUIREMENT = "CONFIRM_DELETE_RECRUITMENT_REQUIREMENT", // modal xác nhận xóa yêu cầu tuyển dụng
  EDIT_RECRUITMENT_REQUIREMENT = "EDIT_RECRUITMENT_REQUIREMENT", // modal chỉnh sửa thêm mới xóa yêu cầu tuyển dụng
  DETAIL_RECRUITMENT_REQUIREMENT = "DETAIL_RECRUITMENT_REQUIREMENT", // modal xác nhận xóa yêu cầu tuyển dụng
  FORWARD_RECRUITMENT_EVALUATION = "FORWARD_RECRUITMENT_EVALUATION", // modal chuyển tiếp đánh giá tuyển dụng
  CONFIRM_REJECT_EVALUATION = "CONFIRM_REJECT_EVALUATION", // xác nhận đánh giá k đạt
}

export enum DIALOG_STATUS {
  OPEN = "OPEN",
  CLOSE = "CLOSE",
}
